type StudyCardCandidate = {
  startedStudyingAt: string | null;
};

function startedStudyingAtMs(card: StudyCardCandidate): number {
  return card.startedStudyingAt === null
    ? Number.POSITIVE_INFINITY
    : new Date(card.startedStudyingAt).getTime();
}

/**
 * Per subject, the study card started earliest; ties keep the first card listed. Cards whose
 * `subjectOf` is `undefined` do not establish a subject.
 */
export function selectEarliestStartedStudyCards<const TStudyCard extends StudyCardCandidate>(
  studyCards: readonly TStudyCard[],
  subjectOf: (studyCard: TStudyCard) => string | undefined,
): ReadonlyMap<string, TStudyCard> {
  const studyCardBySubject = new Map<string, TStudyCard>();

  for (const studyCard of studyCards) {
    const subject = subjectOf(studyCard);
    if (subject === undefined) {
      continue;
    }

    const existing = studyCardBySubject.get(subject);
    if (existing === undefined || startedStudyingAtMs(studyCard) < startedStudyingAtMs(existing)) {
      studyCardBySubject.set(subject, studyCard);
    }
  }

  return studyCardBySubject;
}
